import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

import LoadingView from './view/loading';
import EntryView from './view/entry';
import AdminView from './view/admin';

Amplify.configure(awsconfig);

function App(props) {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<EntryView />} />
          <Route path='/entry' element={<EntryView />} />
          <Route path='/admin' element={<AdminView />} />
        </Routes>
      </BrowserRouter>
      <LoadingView />
    </>
  );
}

export default App;
